var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clicking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9905 20.8093C10.1262 20.8093 9.39253 20.2871 9.07424 19.5502L8.5122 18.2488L7.54689 19.2141C6.7312 20.0298 5.41094 20.0298 4.59521 19.2141C3.77952 18.3984 3.77948 17.0781 4.59521 16.2624L5.56052 15.2971L4.25911 14.7351C3.5228 14.4171 3 13.6837 3 12.8188C3 11.8369 3.67481 11.0203 4.57963 10.7941L12.4508 8.82632C13.1586 8.64933 13.9186 8.85968 14.4341 9.37521C14.9497 9.89073 15.16 10.6507 14.983 11.3586L13.0152 19.2297C12.7894 20.1329 11.9745 20.8093 10.9905 20.8093ZM8.74468 16.3367C8.78812 16.3367 8.83181 16.3408 8.8753 16.3491C9.10172 16.3923 9.292 16.545 9.38338 16.7566L10.3516 18.9985C10.4563 19.241 10.6999 19.4179 10.9905 19.4179C11.3231 19.4179 11.5916 19.1873 11.6653 18.8923L13.6331 11.0211C13.6931 10.7811 13.6247 10.5336 13.4502 10.3591C13.2757 10.1846 13.0282 10.1163 12.7882 10.1763L4.91708 12.144C4.62203 12.2178 4.39143 12.4862 4.39143 12.8188C4.39143 13.1101 4.56902 13.3533 4.81081 13.4577L7.05273 14.4259C7.26433 14.5173 7.41697 14.7076 7.46024 14.934C7.50352 15.1604 7.43186 15.3936 7.26885 15.5566L5.57909 17.2463C5.30717 17.5183 5.30717 17.9583 5.57909 18.2302C5.85101 18.5021 6.29109 18.5021 6.56298 18.2302L8.25273 16.5405C8.38443 16.4088 8.56195 16.3367 8.74468 16.3367Z",
    fill: "#A4A8AE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1192 10.9823H17.3363C16.9521 10.9823 16.6406 10.6708 16.6406 10.2865C16.6406 9.90229 16.9521 9.59082 17.3363 9.59082H20.1192C20.5035 9.59082 20.8149 9.90229 20.8149 10.2865C20.8149 10.6708 20.5035 10.9823 20.1192 10.9823Z",
    fill: "#A4A8AE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5895 15.6994L15.6218 13.7316C15.35 13.4599 15.35 13.0194 15.6218 12.7477C15.8935 12.476 16.334 12.476 16.6056 12.7477L18.5734 14.7155C18.8451 14.9872 18.8451 15.4277 18.5734 15.6994C18.3017 15.971 17.8612 15.971 17.5895 15.6994Z",
    fill: "#A4A8AE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.0349 8.19253L8.06707 6.22476C7.79535 5.95305 7.79535 5.51256 8.06707 5.24088C8.33878 4.9692 8.77927 4.96917 9.05095 5.24088L11.0188 7.20865C11.2905 7.48036 11.2905 7.92085 11.0188 8.19253C10.747 8.46421 10.3065 8.46421 10.0349 8.19253Z",
    fill: "#A4A8AE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.4809 7.1743C13.0966 7.1743 12.7852 6.86283 12.7852 6.47859V3.69572C12.7852 3.31147 13.0966 3 13.4809 3C13.8651 3 14.1766 3.31147 14.1766 3.69572V6.47859C14.1766 6.86283 13.8651 7.1743 13.4809 7.1743Z",
    fill: "#A4A8AE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.9426 8.19254C15.6708 7.92083 15.6708 7.48034 15.9426 7.20866L17.9103 5.24089C18.182 4.96918 18.6225 4.96918 18.8942 5.24089C19.1659 5.51261 19.1659 5.9531 18.8942 6.22478L16.9264 8.19254C16.6548 8.46422 16.2143 8.46422 15.9426 8.19254Z",
    fill: "#A4A8AE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorPointer);
export default __webpack_public_path__ + "static/media/cursor-pointer.25099460bf05c26cb99bbd8a50451e05.svg";
export { ForwardRef as ReactComponent };